import { Box, Typography, Skeleton, Alert } from '@mui/material'
import { useQuery } from 'react-query'
import { getLeadAssignmentUniqueReportRequest } from '../../Utils/RestUtils'
import dayjs from 'dayjs'

const CACHE_DURATION = 60 * 60 * 1000

export default function AgentLeads() {
  const userId = localStorage.getItem('user_id')
  const isAdmin = localStorage.getItem('permissions')?.includes('ROLE_ADMIN')
  const today = dayjs().format('YYYY-MM-DD')
  const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD')
  const startOfWeek = dayjs().startOf('week').add(1, 'day').format('YYYY-MM-DD')

  if (isAdmin) return null

  const {
    data: dailyCountResponse,
    isLoading: dailyLoading,
    error: dailyError,
  } = useQuery(
    ['lead-assignment-unique', 'daily', today],
    () =>
      getLeadAssignmentUniqueReportRequest({
        from: today,
        to: tomorrow,
        mainUser: userId,
      }),
    {
      staleTime: CACHE_DURATION,
      cacheTime: CACHE_DURATION,
    }
  )

  const {
    data: weeklyCountResponse,
    isLoading: weeklyLoading,
    error: weeklyError,
  } = useQuery(
    ['lead-assignment-unique', 'weekly', startOfWeek],
    () =>
      getLeadAssignmentUniqueReportRequest({
        from: startOfWeek,
        to: tomorrow,
        mainUser: userId,
      }),
    {
      staleTime: CACHE_DURATION,
      cacheTime: CACHE_DURATION,
    }
  )

  const isLoading = dailyLoading || weeklyLoading
  const error = dailyError || weeklyError

  if (isLoading) {
    return (
      <Box flex={1} sx={{ maxWidth: 'calc(20% - 13px)' }}>
        <Box
          sx={{
            backgroundColor: '#c7b820',
            padding: '16px',
            color: '#fff',
          }}
        >
          <Typography
            variant="h3"
            sx={{ fontSize: 'initial', fontWeight: 'bold', mt: 0 }}
          >
            Leads taken
          </Typography>
          <Skeleton
            width={'100%'}
            height={28}
            sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}
          />
          <Skeleton
            width={'100%'}
            height={28}
            sx={{ bgcolor: 'rgba(255,255,255,0.3)' }}
          />
        </Box>
      </Box>
    )
  }

  if (error) {
    return <Alert severity="error">Failed to fetch lead data: {error}</Alert>
  }

  return (
    <Box flex={1} sx={{ maxWidth: 'calc(20% - 13px)' }}>
      <Box
        sx={{
          backgroundColor: '#c7b820',
          color: '#fff',
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          padding: '16px',
          position: 'relative',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Typography
            variant="h3"
            sx={{ fontSize: 'initial', fontWeight: 'bold', mt: 0 }}
          >
            Leads taken
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>Current day</Box>
          <Box>{dailyCountResponse.data.length}</Box>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>Current week</Box>
          <Box>{weeklyCountResponse.data.length}</Box>
        </Box>
      </Box>
    </Box>
  )
}
